import { CSSProperties, ReactNode } from 'react'
import Skeleton from '~/components/Skeleton'

interface OrderRefreshingProps {
  renderText: string | ReactNode
  loading: boolean
  skeletonStyle?: CSSProperties
}

const OrderRefreshing: React.FC<OrderRefreshingProps> = ({
  renderText,
  loading,
  skeletonStyle = {},
}) => {
  return loading ? (
    <Skeleton style={skeletonStyle} />
  ) : (
    <span>{renderText}</span>
  )
}

export default OrderRefreshing
